// Dernière fiche parcelle chargée, gardée sur l'appareil (IndexedDB) pour la consulter hors réseau.
// Toute erreur (navigation privée, stockage plein ou bloqué) est ignorée : la fiche s'affiche sans cache.

const DB_NAME = "veyerciel-fiches";
const STORE = "fiches";

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") return reject(new Error("IndexedDB indisponible"));
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE, { keyPath: "key" });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function run(mode, fn) {
  return openDb().then((db) => new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode);
    const req = fn(tx.objectStore(STORE));
    tx.oncomplete = () => { db.close(); resolve(req?.result); };
    tx.onerror = () => { db.close(); reject(tx.error); };
  }));
}

// Une entrée par parcelle et par vue (îlot, période) : la vue par défaut a la clé de la parcelle seule.
export const ficheKey = (parcelId, query = "") => (query ? `${parcelId}?${query}` : parcelId);

export async function saveFiche(key, fiche) {
  try {
    await run("readwrite", (s) => s.put({ key, fiche, saved_at: new Date().toISOString() }));
  } catch { /* cache facultatif */ }
}

export async function loadFiche(key) {
  try {
    return (await run("readonly", (s) => s.get(key))) || null;
  } catch {
    return null;
  }
}
